/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $MasterTypeCode = {
  type: 'Enum',
} as const;
